import React from 'react';
import {
  Box,
  Inscription,
  ShimmerBox,
} from '@common-fe/common-fe';

import { useViewPlanTermination } from './hooks/useViewPlanTermination';
import { Mode, PlanTerminationCoverageDatesForm } from './PlanTerminationCoverageDatesForm';
import { PlanTerminationDateForm } from './PlanTerminationDateForm';
import { PlanTerminationHsaTransferForm } from './PlanTerminationHsaTransferForm';
      
const ViewPlanTerminationModalForm: React.FC= () => {    
   const {
    isPendingTermination,
    planName,
    currentTerminationDate,
    coverageData,
    isHsaAccount,
    formattedData,
    terminationDataLoading,
   } = useViewPlanTermination();
  return (
    <>
      <Box margin={{ bottom: 'spacing24' }} align="center">
        {isPendingTermination ? (
          <>
            <Box margin={{ vertical: 'spacing12' }} width="100%">
              {terminationDataLoading ? (
                <Box width="100%">
                  <ShimmerBox
                    width="100%"
                    height="32px"
                    background="module"
                    round="container1Round"
                  />
                </Box>
                ) : (
                <Inscription size="24px" weight={700} lineHeight="32px" textAlign="center">
                {planName || 'Plan'} has scheduled termination on {currentTerminationDate}
                </Inscription>
              )}
            </Box>
            {terminationDataLoading ? (
              <Box width="100%">
                <ShimmerBox
                  width="100%"
                  height="32px"
                  background="module"
                  round="container1Round"
                />
              </Box>
              ) : (
              <Inscription textAlign="center" size="14px">
              Please note that you can edit or cancel termination configurations until {currentTerminationDate}.
              </Inscription>
            )}
          </>
        ) : (
          <Inscription size="24px" weight={700} lineHeight="32px" textAlign="center">
            Plan has terminated
          </Inscription>
        )}
      </Box>
    
      <Box data-testid="ViewPlanTerminationModalForm_container">
        <Box direction="column">
          <Box
            round="container1Round"
            pad="spacing24"
            background="module"
            gap='spacing24'
          >
            {terminationDataLoading ? (
              <Box width="100%">
                <ShimmerBox
                  width="100%"
                  height="88px"
                  background="module"
                  round="container1Round"
                />
              </Box>
            )
            : (
              <PlanTerminationDateForm
                terminationDate={formattedData?.terminationDate}
                viewMode
              />)}
            {terminationDataLoading ? (
              <Box width="100%">
                <ShimmerBox
                  width="100%"
                  height="180px"
                  background="module"
                  round="container1Round"
                />
              </Box>
            ) : (
              <Box gap="spacing24">
                <PlanTerminationCoverageDatesForm mode={Mode.COVERAGES} coveragesList={coverageData} />
    
                {isHsaAccount ? (
                  <PlanTerminationHsaTransferForm
                    defaultHsaTransferOfAssets={formattedData?.hsaTransferOfAssets}
                    viewMode
                  />
                ) : null}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};
      
export default ViewPlanTerminationModalForm;
      